import { render, staticRenderFns } from "./Open-end-writing.vue?vue&type=template&id=406a2aa8"
import script from "./Open-end-writing.vue?vue&type=script&lang=js"
export * from "./Open-end-writing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports